import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'documents/document';
const model = 'documents/document';
const wizardName = 'Generic File association';
const wizardObject = 'Document';
const wizardAction = 'genericFileAssociation';

const GenericFileAssociation = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities } = useContext(AppContext);

    // DATA PROVIDER
    const {
        item,
        save,
        errorMessage,
        errors,
        saving,
        success
    } = useDataProvider(dataProviderName, true);

    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const detailConfig = {
        "tabs": [
            {
                "name": "document",
                "fieldsets": [
                    {
                        "name": "document",
                        "fields": {
                            "file": {
                                "type": "dropzone",
                                "required": true,
                                "className": "col-12",
                                "icon": "faFile"
                            },
                            "type": {
                                "type": "select",
                                "required": true,
                                "options": [
                                    {
                                        "label": "carPicture",//Libretto di Circolazione
                                        "value": "carPicture"
                                    },
                                    {
                                        "label": "vehicleRegistration",//Libretto di Circolazione
                                        "value": "vehicleRegistration"
                                    },
                                    {
                                        "label": "insurance",//Assicurazione
                                        "value": "insurance"
                                    },
                                    {
                                        "label": "activeClaimReport",//Denuncia Sinistro Attivo
                                        "value": "activeClaimReport"
                                    },
                                    {
                                        "label": "passiveClaimReport",//Denuncia Sinistro Passivo
                                        "value": "passiveClaimReport"
                                    },
                                    {
                                        "label": "article94",//Articolo 94
                                        "value": "article94"
                                    },
                                    {
                                        "label": "recallCampaign",//Campagna di richiamo
                                        "value": "recallCampaign"
                                    },
                                    {
                                        "label": "recallCampaignCompleted",//Campagna di richiamo
                                        "value": "recallCampaignCompleted"
                                    },
                                    {
                                        "label": "fuelCardAssignment",//Assegnazione Fuel Card
                                        "value": "fuelCardAssignment"
                                    },
                                    {
                                        "label": "drivingDelegation",//Delega alla Guida
                                        "value": "drivingDelegation"
                                    },
                                    {
                                        "label": "partialTheftReport",//Denuncia Furto Parziale
                                        "value": "partialTheftReport"
                                    }, ,
                                    {
                                        "label": "deliveryReport",//Verbale di Consegna
                                        "value": "deliveryReport"
                                    },
                                    {
                                        "label": "returnReport",//Verbale di Riconsegna
                                        "value": "returnReport"
                                    },
                                    {
                                        "label": "fiscalReceipt",//Scontrino
                                        "value": "fiscalReceipt"
                                    },

                                ],
                                "className": "col-12",
                                "icon": "faCircleX"
                            },
                            "car": {
                                "type": "relationshipSingle",
                                "relation": {
                                    "drawerRoute": "cars",
                                    "inverseRelation": "document",
                                    "inverseRelationType": "relationshipSingle"
                                },
                                "view": "car"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const car = discover("car");
    if (userCapabilities['auth/role.is_driver'] && car.isPool == 'true') {
        detailConfig.tabs[0].fieldsets[0].fields.type.options =
            [

                {
                    "label": "activeClaimReport",//Denuncia Sinistro Attivo
                    "value": "activeClaimReport"
                },
                {
                    "label": "passiveClaimReport",//Denuncia Sinistro Passivo
                    "value": "passiveClaimReport"
                },
                {
                    "label": "drivingDelegation",//Delega alla Guida
                    "value": "drivingDelegation"
                },
                {
                    "label": "partialTheftReport",//Denuncia Furto Parziale
                    "value": "partialTheftReport"
                },
                {
                    "label": "fiscalReceipt",//Scontrino
                    "value": "fiscalReceipt"
                },
            ]
    }

    useEffect(() => {
        if (success) {
            close();
        }
    }, [success]);

    const handleSave = async (data) => {
        save && save({ ...data, filters: params.filters })
    }

    return <>
        <DetailComponent
            values={{
                "car": car,
                "visibleToDriver": "true",
                "name": t("document") + (car?.plate ? ' ' + car?.plate : '')
            }}
            modelName={model.split('/')[1]}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Add a {{wizardObject}} to {{plate}}', { wizardObject: wizardObject, plate: car?.plate })}
                />
            }
            {...params}
        />
    </>
}

export default GenericFileAssociation;


